"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIndirectDispatchTemplate = getIndirectDispatchTemplate;
const index_1 = require("./index");
function getIndirectDispatchTemplate(includeMacroOps = false) {
    return `
                            // Indirect dispatch via handler array with randomized indices
                            // _h = handler array, _hm = opcode-to-handler mapping
                            // Handler indices are shuffled per-build for additional obfuscation
                            if (typeof _h === 'undefined') {
                                var _vmDone = false;
                                var _vmReturnValue;
                                var _h = [];  // Handler array (sparse, indexed by shuffled values)
                                var _hm = {}; // Opcode to handler index mapping

                                // Generate shuffled handler indices at runtime
                                // This ensures each execution has different handler layout
                                var _opcodes = [];
                                for (var _k in opMap) { if (opMap.hasOwnProperty(_k)) _opcodes.push(parseInt(_k)); }
                                var _shuffled = _opcodes.slice();
                                for (var _i = _shuffled.length - 1; _i > 0; _i--) {
                                    var _j = Math.floor(Math.random() * (_i + 1));
                                    var _t = _shuffled[_i]; _shuffled[_i] = _shuffled[_j]; _shuffled[_j] = _t;
                                }
                                // Build mapping: opcode -> shuffled handler index
                                for (var _i = 0; _i < _opcodes.length; _i++) {
                                    _hm[opMap[_opcodes[_i]]] = _shuffled[_i];
                                }

                                // Single dispatch function that uses switch internally
                                // The indirection is: op -> _hm[op] -> _h[_hm[op]]
                                var _dispatch = function(_op, _arg) {
                                    var arg = _arg;
                                    switch(_op) {
                                        ${(0, index_1.getAllOpcodeCasesForIndirectDispatch)(includeMacroOps)}
                                    }
                                };

                                // Populate handler array at shuffled indices
                                // Each "handler" is a closure that calls dispatch with the original opcode
                                for (var _k in opMap) {
                                    if (opMap.hasOwnProperty(_k)) {
                                        (function(physicalOp) {
                                            _h[_hm[physicalOp]] = function(_arg) { _dispatch(physicalOp, _arg); };
                                        })(opMap[_k]);
                                    }
                                }
                            }
                            // Dispatch through handler array with mapped index
                            _h[_hm[op]](arg);
                            if (_vmDone) { _vmDone = false; return _vmReturnValue; }
    `;
}
